import React from 'react';
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const OrderCancel = () => {
    return (
        <>
            <SEO title="Payment Cancel" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container text-center">
                        <div className='w-75 mx-auto'>
                            <h2 className="text-3xl font-bold mb-4">Your Order is Cancelled</h2>
                            <h3 className="mb-6 text-lg">If You Think There is Problem <Link to="/contact" className="text-primary">CONTACT US</Link></h3>
                            <Link to="/" className="btn-default">Go to Homepage</Link>
                        </div>
                    </div>
                </div>

                <FooterOne />
                <Copyright />
            </main>
        </>
    );
};

export default OrderCancel;
